import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '16px',
    textAlign: 'center',
    height: '100%',

    // Push the action button to the bottom on fullscreen Popup (no-op desktop).
    '& > button:last-child': {
      marginTop: 'auto',
    },
  },
  inputContainer: {
    ...dFlex('unset', 'flex-end'),
    flexDirection: 'column',
    gap: 4,
    width: '100%',
  },
  skeleton: {
    width: '60px !important',
  },
  totalBlock: {
    display: 'grid',
    gridTemplateColumns: '1fr 1px 1fr',
    gap: '12px',
    alignItems: 'stretch',
    padding: '20px',
    background: theme.palette.custom.background.light,
    border: `1px solid ${theme.palette.custom.border.primary}`,
    borderRadius: theme.borderRadius.lg,
  },
  priceColumn: {
    ...dFlex('center', 'center'),
    flexDirection: 'column',
    gap: 4,
  },
  value: {
    ...dFlex('center', 'center'),
    gap: 4,
  },
  separator: {
    width: 1,
    background: theme.palette.custom.border.separator,
    alignSelf: 'stretch',
  },
}));

export default useStyles;
